/* GemKrishna – Buy Rudraksha page (sections/gk-rudraksha-shop.liquid).
   Enhancement only: a row of filter dropdowns (each clearable), sorting, size -> price display and
   add-to-cart without a reload. Prices and variant IDs are read from the server-rendered cards,
   never computed here. */
(function () {
  'use strict';
  var root = document.querySelector('[data-gkrs]');
  if (!root) return;

  var grid = root.querySelector('[data-gkrs-grid]');
  var cards = Array.prototype.slice.call(grid.querySelectorAll('.gkrs-card'));
  var filters = root.querySelector('[data-gkrs-filters]');
  var countEl = root.querySelector('[data-gkrs-count]');
  var emptyEl = root.querySelector('[data-gkrs-empty]');
  var activeBox = root.querySelector('[data-gkrs-active]');
  var activeList = root.querySelector('[data-gkrs-active-list]');
  var resetBtns = root.querySelectorAll('[data-gkrs-reset]');
  var shopEl = root.querySelector('#gkrs-shop');
  var total = cards.length;
  var shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // One dropdown per filter. "key" is the state property and the URL parameter.
  var controls = [
    { key: 'origin', label: 'Origin', el: root.querySelector('[data-gkrs-origin-select]') },
    { key: 'type', label: 'Mukhi', el: root.querySelector('[data-gkrs-type]') },
    { key: 'size', label: 'Size', el: root.querySelector('[data-gkrs-size]') },
    { key: 'budget', label: 'Budget', el: root.querySelector('[data-gkrs-budget-select]') }
  ];
  var sortSel = root.querySelector('[data-gkrs-sort]');
  var state = { origin: '', type: '', size: '', budget: '', sort: 'rank' };

  cards.forEach(function (c, i) { c.dataset.order = i; });

  /* ---------- helpers ---------- */
  function sizeInputs(card) {
    return Array.prototype.slice.call(card.querySelectorAll('input[type="radio"][name="id"]'));
  }
  function budgetRange() {
    if (!state.budget) return null;
    var p = state.budget.split('-');
    return [Number(p[0]) * 100, p[1] ? Number(p[1]) * 100 : Infinity];
  }
  // Lowest purchasable price on a card that satisfies the size and budget filters (in paise).
  function matchPrice(card) {
    var range = budgetRange();
    var inputs = sizeInputs(card);
    if (!inputs.length) {
      if (card.hasAttribute('data-enquiry')) return (state.size || state.budget) ? null : Infinity;
      if (state.size || !card.dataset.min) return null;
      var m = Number(card.dataset.min);
      if (range && (m < range[0] || m >= range[1])) return null;
      return m;
    }
    var best = null;
    inputs.forEach(function (inp) {
      if (inp.disabled) return;
      if (state.size && inp.dataset.size !== state.size) return;
      var pr = Number(inp.dataset.price);
      if (range && (pr < range[0] || pr >= range[1])) return;
      if (best === null || pr < best) best = pr;
    });
    return best;
  }
  function optionText(sel, value) {
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].value === value) return sel.options[i].text.replace(/\s*\(\d+\)$/, '');
    }
    return value;
  }
  function optionExists(sel, v) {
    if (!v) return false;
    return Array.prototype.some.call(sel.options, function (o) { return o.value === v; });
  }
  function activeCount() {
    return controls.filter(function (c) { return state[c.key]; }).length;
  }

  /* ---------- filtering ---------- */
  function apply(fromUser) {
    var shown = [];
    var range = budgetRange();
    cards.forEach(function (card) {
      var ok = true;
      if (state.origin && card.dataset.origin !== state.origin) ok = false;
      if (ok && state.type && card.dataset.type !== state.type) ok = false;
      var price = ok ? matchPrice(card) : null;
      if (price === null) ok = false;
      card.hidden = !ok;
      card.dataset.match = ok ? price : '';
      // Sizes that match the size/budget filters stay bright; the rest are dimmed but still selectable.
      sizeInputs(card).forEach(function (inp) {
        var pr = Number(inp.dataset.price);
        var dim = (state.size && inp.dataset.size !== state.size) || (range && (pr < range[0] || pr >= range[1]));
        inp.closest('.gkrs-size').classList.toggle('is-dim', !!dim);
      });
      if (ok) shown.push(card);
    });

    shown.sort(function (a, b) {
      if (state.sort === 'price-asc' || state.sort === 'price-desc') {
        var pa = Number(a.dataset.match), pb = Number(b.dataset.match);
        if (!isFinite(pa)) return 1;
        if (!isFinite(pb)) return -1;
        if (pa !== pb) return state.sort === 'price-asc' ? pa - pb : pb - pa;
      }
      return Number(a.dataset.order) - Number(b.dataset.order);
    });
    var frag = document.createDocumentFragment();
    shown.forEach(function (c) { frag.appendChild(c); });
    cards.forEach(function (c) { if (c.hidden) frag.appendChild(c); });
    grid.appendChild(frag);

    var n = activeCount();
    countEl.textContent = n ? 'Showing ' + shown.length + ' of ' + total + ' Rudraksha types' : total + ' Rudraksha types';
    emptyEl.hidden = shown.length > 0;
    grid.hidden = shown.length === 0;
    renderActive();
    syncControls();
    if (fromUser) writeUrl();
  }

  // Selected filters as removable chips, plus "Clear all"
  function renderActive() {
    activeList.innerHTML = '';
    controls.forEach(function (c) {
      if (!state[c.key]) return;
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gkrs-active__chip';
      var text = optionText(c.el, state[c.key]);
      b.setAttribute('aria-label', 'Remove filter ' + c.label + ': ' + text);
      b.appendChild(document.createTextNode(text));
      var x = document.createElement('span');
      x.setAttribute('aria-hidden', 'true');
      x.textContent = '×';
      b.appendChild(x);
      b.addEventListener('click', function () { state[c.key] = ''; apply(true); c.el.focus(); });
      li.appendChild(b);
      activeList.appendChild(li);
    });
    activeBox.hidden = activeCount() === 0;
  }

  function syncControls() {
    controls.forEach(function (c) {
      c.el.value = state[c.key];
      c.el.closest('.gkrs-dd').classList.toggle('is-active', !!state[c.key]);
    });
    sortSel.value = state.sort;
  }

  /* ---------- URL state (shareable filtered views) ---------- */
  function readUrl() {
    var q = new URLSearchParams(location.search);
    controls.forEach(function (c) {
      var v = (q.get(c.key) || '').split(',')[0];
      state[c.key] = optionExists(c.el, v) ? v : '';
    });
    state.sort = optionExists(sortSel, q.get('sort')) ? q.get('sort') : 'rank';
  }
  function writeUrl() {
    var q = new URLSearchParams(location.search);
    controls.forEach(function (c) { q.delete(c.key); if (state[c.key]) q.set(c.key, state[c.key]); });
    q.delete('sort');
    if (state.sort !== 'rank') q.set('sort', state.sort);
    var s = q.toString();
    history.replaceState(null, '', location.pathname + (s ? '?' + s : '') + location.hash);
  }

  /* ---------- controls ---------- */
  controls.forEach(function (c) {
    c.el.addEventListener('change', function () { state[c.key] = c.el.value; apply(true); });
  });
  sortSel.addEventListener('change', function () { state.sort = sortSel.value; apply(true); });
  Array.prototype.forEach.call(resetBtns, function (b) {
    b.addEventListener('click', function () {
      controls.forEach(function (c) { state[c.key] = ''; });
      apply(true);
    });
  });

  // "Show Nepal Rudraksha" / benefit links in the guides filter the list and scroll to it
  Array.prototype.forEach.call(root.querySelectorAll('[data-gkrs-quick]'), function (a) {
    a.addEventListener('click', function (e) {
      try {
        var q = JSON.parse(a.dataset.gkrsQuick);
        e.preventDefault();
        controls.forEach(function (c) { state[c.key] = ''; });
        state.origin = (q.origin && q.origin[0]) || '';
        state.type = q.type || '';
        apply(true);
        shopEl.scrollIntoView({ block: 'start' });
      } catch (err) { /* fall back to the plain link */ }
    });
  });

  /* ---------- cards: size selection and add to cart ---------- */
  Array.prototype.forEach.call(root.querySelectorAll('[data-gkrs-form]'), function (form) {
    var card = form.closest('.gkrs-card');
    var priceEl = card.querySelector('[data-gkrs-price]');
    var btn = form.querySelector('[data-gkrs-add]');
    var msg = form.querySelector('[data-gkrs-msg]');
    var needsSize = btn.hasAttribute('data-needs-size');
    var customise = form.querySelector('[data-gkrs-customise]');
    form.noValidate = true; // our own "choose a size" message replaces the browser bubble

    function selected() { return form.querySelector('input[name="id"]:checked'); }
    function refresh() {
      var sel = selected();
      // "Customise" opens the product page at the customiser, with the chosen size pre-selected
      if (customise) customise.href = customise.dataset.base + (sel ? '?variant=' + sel.value : '') + '#customise';
      if (!needsSize) return;
      if (sel) {
        priceEl.innerHTML = '';
        priceEl.appendChild(document.createTextNode(sel.dataset.money + ' '));
        var small = document.createElement('small');
        small.textContent = 'for ' + sel.dataset.size;
        priceEl.appendChild(small);
        btn.removeAttribute('aria-disabled');
        btn.textContent = 'Add to cart';
      } else {
        btn.setAttribute('aria-disabled', 'true');
        btn.textContent = 'Select a size';
      }
    }
    if (needsSize) refresh();
    form.addEventListener('change', function (e) {
      if (e.target.name === 'id') { msg.textContent = ''; msg.classList.remove('is-error'); refresh(); }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (needsSize && !selected()) {
        showMsg('Please choose a bead size first.', true);
        var first = form.querySelector('input[name="id"]:not(:disabled)');
        if (first) first.focus();
        return;
      }
      var fd = new FormData(form);
      var qty = Math.max(1, Math.min(108, parseInt(fd.get('quantity'), 10) || 1));
      fd.set('quantity', String(qty));
      fd.append('sections', 'cart-icon-bubble');
      fd.append('sections_url', location.pathname);
      btn.classList.add('is-busy');
      btn.setAttribute('aria-busy', 'true');
      fetch(shopRoot + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || 'Could not add to cart');
          updateBubble(res.body.sections);
          var line = res.body;
          var label = line.variant_options && line.variant_options[0] && /mm/.test(line.variant_options[0]) ? ' (' + line.variant_options[0] + ')' : '';
          showMsg('Added to cart' + label + '. ', false, true);
          card.classList.add('is-flash');
          setTimeout(function () { card.classList.remove('is-flash'); }, 1200);
          document.dispatchEvent(new CustomEvent('gk:cart-updated', { detail: line }));
        })
        .catch(function (err) { showMsg(err.message || 'Could not add to cart. Please try again.', true); })
        .then(function () { btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); });
    });

    function showMsg(text, isError, withLink) {
      msg.textContent = text;
      msg.classList.toggle('is-error', !!isError);
      if (withLink) {
        var a = document.createElement('a');
        a.href = shopRoot + 'cart';
        a.textContent = 'View cart';
        msg.appendChild(a);
      }
    }
  });

  function updateBubble(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;
    var el = document.getElementById('cart-icon-bubble');
    if (!el) return;
    var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
    var src = doc.querySelector('.shopify-section') || doc.body;
    el.innerHTML = src.innerHTML;
  }

  /* ---------- init ---------- */
  filters.hidden = false;
  readUrl();
  apply(false);
})();
